// Utility to safely prepend "Dr." to a psychologist's name without duplicating
// the title when the stored name already starts with "Dr" or "Dr.".
export const withDoctorTitle = (name) => {
  if (!name) return '';
  const stripped = String(name).replace(/^\s*Dr\.?\s+/i, '').trim();
  return `Dr. ${stripped}`;
};
